module.exports = __webpack_public_path__ + "static/media/content.cde396c1.svg";